import LogRepository from "../../ports/logRepository";
import { Log } from "../../../entities/log";

export type updateLogUsecase = (
  applicantId: string,
  data: Log
) => Promise<void>;

export const buildUpdateLog = (dependencies: {
  logRepo: LogRepository;
}): updateLogUsecase => {
  const { logRepo } = dependencies;

  const updateLog: updateLogUsecase = async (applicantId: string, data: Log) =>
    logRepo.updateLog(applicantId, data);

  return updateLog;
};
